<template>
    <div class="order-summary-modal">
        <header class="order-summary-modal__header">
            <h3 class="order-summary-modal__heading">
                Preiszusammenstellung
            </h3>
        </header>
        <div
            :class="{'order-summary-modal__col-container--border-visible' : wednesdayDelivery && Object.keys(groupedBaskets['monday']).length} "
            class="order-summary-modal__col-container"
        >
            <div
                class="order-summary-modal__col order-summary-modal__col-1"
                v-if="(mode === 'business' && mondayDelivery) || (mode==='private' && privateDeliveryDay === 'monday')"
            >
                <div class="order-summary-modal-details">
                    <h4 class="order-summary-modal-details__heading">
                        Montag
                    </h4>
                    <div class="order-summary-modal-details__sub-heading">
                        {{ interval('monday').name }}
                    </div>
                    <table
                        class="order-summary-modal-details__table"
                        v-if="Object.keys(groupedBaskets['monday']).length"
                    >
                        <tr>
                            <th class="order-summary-modal-details__th">
                                {{ subscriptionType.name }}-Korb
                            </th>
                            <th class="order-summary-modal-details__th"/>
                            <th
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__th"
                            />
                        </tr>
                        <tr
                            v-for="(basketId, basketIndex) in Object.keys(groupedBaskets['monday'])"
                            :key="`baskets-sizes-monday-${basketIndex}`"
                        >
                            <td class="order-summary-modal-details__td">
                                {{ basketRowLabel('monday', basketId) }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> {{ basketPrice(basketId) | round | formatPrice }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ basketSumPrice('monday', basketIndex, basketId) | round | formatPrice }}
                            </td>
                        </tr>
                    </table>
                    <table
                        class="order-summary-modal-details__table"
                    >
                        <tr>
                            <th class="order-summary-modal-details__th">
                                Extras
                            </th>
                            <th class="order-summary-modal-details__th"/>
                            <th
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__th"
                            />
                        </tr>
                        <tr
                            v-for="(basketId, basketIndex) in Object.keys(groupedBasketsExtra['monday'])"
                            :key="`baskets-extra-monday-${basketIndex}`"
                        >
                            <td class="order-summary-modal-details__td">
                                {{ extraRowLabel('monday', basketId) }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> CHF {{ groupedBasketsExtra['monday'][basketId][0].price | round }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ extraBasketPrice('monday', basketId, true) | round | formatPrice }}
                            </td>
                        </tr>
                    </table>
                    <table
                        class="order-summary-modal-details__table"
                    >
                        <tr>
                            <th class="order-summary-modal-details__th">
                                Lieferpauschalen
                            </th>
                            <th class="order-summary-modal-details__th"/>
                            <th
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__th"
                            />
                        </tr>
                        <tr>
                            <td class="order-summary-modal-details__td">
                                {{ feeRowLabel('monday', 'Lieferung') }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> {{ deliveryFee | round | formatPrice }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ getFeeTotal('monday', deliveryFee, true) | round | formatPrice }}
                            </td>
                        </tr>
                        <tr v-if="earlyInvoice">
                            <td class="order-summary-modal-details__td">
                                {{ feeRowLabel('monday', 'Frühlieferung') }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> {{ earlyDeliveryFee | round | formatPrice }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ getFeeTotal('monday', earlyDeliveryFee, true) | round | formatPrice }}
                            </td>
                        </tr>
                    </table>
                    <div class="order-summary-modal-details__section-total-container">
                        <div class="order-summary-modal-details__section-total-label">
                            Zwischentotal
                        </div>
                        <div class="order-summary-modal-details__section-total-amount">
                            {{ (mode === 'business' ? dayTotalPerWeek('monday', 'all') : dayTotal('monday', 'all', true)) | round | formatPrice }}
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="order-summary-modal__col order-summary-modal__col-2"
                v-if="wednesdayDelivery"
            >
                <div class="order-summary-modal-details">
                    <h4 class="order-summary-modal-details__heading">
                        Mittwoch
                    </h4>
                    <div class="order-summary-modal-details__sub-heading">
                        {{ interval('wednesday').name }}
                    </div>
                    <table
                        class="order-summary-modal-details__table"
                        v-if="Object.keys(groupedBaskets['wednesday']).length"
                    >
                        <tr>
                            <th class="order-summary-modal-details__th">
                                {{ subscriptionType.name }}-Korb
                            </th>
                            <th class="order-summary-modal-details__th"/>
                            <th
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__th"
                            />
                        </tr>
                        <tr
                            v-for="(basketId, basketIndex) in Object.keys(groupedBaskets['wednesday'])"
                            :key="`baskets-sizes-wednesday-${basketIndex}`"
                        >
                            <td class="order-summary-modal-details__td">
                                {{ basketRowLabel('wednesday', basketId) }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> {{ basketPrice(basketId) | round | formatPrice }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ basketSumPrice('wednesday', basketIndex, basketId) | round | formatPrice }}
                            </td>
                        </tr>
                    </table>
                    <table
                        class="order-summary-modal-details__table"
                    >
                        <tr>
                            <th class="order-summary-modal-details__th">
                                Extras
                            </th>
                            <th class="order-summary-modal-details__th"/>
                            <th
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__th"
                            />
                        </tr>
                        <tr
                            v-for="(basketId, basketIndex) in Object.keys(groupedBasketsExtra['wednesday'])"
                            :key="`baskets-extra-wednesday-${basketIndex}`"
                        >
                            <td class="order-summary-modal-details__td">
                                {{ extraRowLabel('wednesday', basketId) }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> CHF {{ groupedBasketsExtra['wednesday'][basketId][0].price | round }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ extraBasketPrice('wednesday', basketId, true) | round | formatPrice }}
                            </td>
                        </tr>
                    </table>
                    <table
                        class="order-summary-modal-details__table"
                    >
                        <tr>
                            <th class="order-summary-modal-details__th">
                                Lieferpauschalen
                            </th>
                            <th class="order-summary-modal-details__th"/>
                            <th
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__th"
                            />
                        </tr>
                        <tr>
                            <td class="order-summary-modal-details__td">
                                {{ feeRowLabel('wednesday', 'Lieferung') }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> {{ deliveryFee | round | formatPrice }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ getFeeTotal('wednesday', deliveryFee, true) | round | formatPrice }}
                            </td>
                        </tr>
                        <tr v-if="earlyInvoice">
                            <td class="order-summary-modal-details__td">
                                {{ feeRowLabel('wednesday', 'Frühlieferung') }}
                            </td>
                            <td class="order-summary-modal-details__td">
                                <span v-if="mode !== 'business'">à</span> {{ earlyDeliveryFee | round | formatPrice }}
                            </td>
                            <td
                                v-if="mode !== 'business'"
                                class="order-summary-modal-details__td"
                            >
                                {{ getFeeTotal('wednesday', earlyDeliveryFee, true) | round | formatPrice }}
                            </td>
                        </tr>
                    </table>
                    <div class="order-summary-modal-details__section-total-container">
                        <div class="order-summary-modal-details__section-total-label">
                            Zwischentotal
                        </div>
                        <div class="order-summary-modal-details__section-total-amount">
                            {{ (mode === 'business' ? dayTotalPerWeek('wednesday', 'all') : dayTotal('wednesday', 'all', true)) | round | formatPrice }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- {# total #} -->
        <div class="order-summary-modal-total">
            <div class="order-summary-modal-total__label">
                Total pro {{ mode === 'private' ? 'Lieferung' : 'Woche' }}:
            </div>
            <div class="order-summary-modal-total__amount">
                {{ (mode === 'business' ? totalPerWeek('all') : total('all')) | round | formatPrice }}
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';

import priceMixin from '../mixins/priceMixin';
import filters from '../mixins/filters';

export default {
    mixins: [
        priceMixin,
        filters,
    ],
    computed: {
        ...mapState({
            baskets: state => state.baskets,
            intervals: state => state.intervals,
            orderableIntervals: state => state.orderable.intervals,
            orderableSubscriptionTypes: state => state.orderable.product_groups,
            earlyInvoice: state => state.earlyInvoice,
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
            earlyDeliveryFee: state => state.orderable.earlyDeliveryFee,
            deliveryFee: state => state.orderable.deliveryFee,
        }),
        ...mapGetters([
            'groupedBaskets',
            'orderableBaskets',
            'allBaskets',
            'subscriptionType',
            'basketExtra',
            'groupedBasketsExtra',
        ]),
        wednesdayDelivery() {
            return Object.keys(this.groupedBaskets.wednesday).length || Object.keys(this.groupedBasketsExtra.wednesday).length;
        },
        mondayDelivery() {
            return Object.keys(this.groupedBaskets.monday).length || Object.keys(this.groupedBasketsExtra.monday).length;
        },
        basketExtraGrouped() {
            return {
                monday: _.groupBy(this.basketExtra.monday, 'id'),
                wednesday: _.groupBy(this.basketExtra.wednesday, 'id'),
            };
        },
    },
    mounted() {
        // GTM VirtualPageview
        const { dataLayer } = window;
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: 'VirtualPageview',
                virtualPageURL: `/de/${this.mode === 'business' ? 'bio-furs-buro' : 'bio-fur-dihei'}/preiszusammenstellung`,
                virtualPageTitle: `Abo Bestellen ${this.mode === 'business' ? 'Büro' : 'Zuhause'} - Preiszusammenstellung`,
            });
        }
    },
};
</script>



// WEBPACK FOOTER //
// PriceSummaryOverview.vue?041af807